import { eventBus } from '@tools/event-bus';
import { FAVORITE_PROPOSAL_EVENT, USER_FAVORITE_ICON_ACTION } from '../constants';

export const initOfferCard = () => {
  if (!document.querySelector('.offer-card')) {
    return;
  }

  window.handleOfferCardFavorite = (target, hashId) => {
    const isActive = target.getAttribute('data-active') === '1';

    window.EventBus.dispatchEvent(new CustomEvent(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE, {
      detail: {
        activeType: USER_FAVORITE_ICON_ACTION.FAVORITE,
        isActive: !isActive,
        offerHashId: hashId,
        offerTeamSizes: [ { hashId, teamSize: null } ],
      },
    }));

    eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE_CALLBACK, (event) => {
      const { offerHashId, favorite } = event.detail;
      if (!offerHashId || offerHashId !== hashId) {
        return false;
      }

      target.setAttribute('data-active', favorite ? '1' : '0');
      // eslint-disable-next-line no-param-reassign
      target.getElementsByClassName('active-icon')[0].style.display = favorite ? 'inline' : 'none';
      // eslint-disable-next-line no-param-reassign
      target.getElementsByClassName('inactive-icon')[0].style.display = favorite ? 'none' : 'inline';

      return true;
    });
  };
};
